import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { MunicipalityTypeDtoModel } from '@heitown/common-dto';

import { ApiClientConfig } from '../api-client-config';
import { BaseCRUDApiClient } from './baseCRUD.api-client';

@Injectable()
export class MunicipalityApiClient extends BaseCRUDApiClient<MunicipalityTypeDtoModel> {
  baseUrl = this.config.apiEndpoint + '/municipality-type';

  constructor(http: HttpClient, config: ApiClientConfig) {
    super(http, config);
  }
}
